// context.js
import { createContext, useContext } from 'react';

export const ThemeModeContext = createContext();

export const useThemeModeContext = () => {
    return useContext(ThemeModeContext);
};